import type { Release } from '../releases.ts';

export default {
  version: '0.6.0',
  date: '2026-09-29',
  title: 'Recycle bin, storage tiers and watch folders',
  summary: [
    'A recycle bin with restore and a retention setting',
    'Storage tiers for originals, proxies, collateral and exports',
    'Watch folders with import settings and XML sidecar metadata',
    'On-premises storage through storage agents',
    'Fixed: Administration tabs no longer loop between addresses',
  ],
  features: [
    'Recycle bin with restore and configurable retention',
    'Storage tiers for originals, proxies, collateral and exports, with server folders added in the UI',
    'Watch folders with per-folder import settings and XML sidecar metadata',
    'On-premises storage through storage agents',
  ],
  fixes: ['Administration tabs no longer loop between addresses', 'Image builds can trust site certificate authorities'],
} satisfies Release;
